export default __webpack_public_path__ + "static/media/Gloves of Bristling Ire.48f1ed11.jpg";